import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs';
import { RemoteLoggingProvider } from '@/logger/providers'
import { LogEntry } from '@/logger';

export class DatadogProvider implements RemoteLoggingProvider {
  constructor(private readonly config: LogsInitConfiguration) {}

  initialize(): void {
    datadogLogs.init(this.config);
  }

  send(entry: LogEntry): void {
    datadogLogs.logger[entry.level](entry.message, {
      data:{
        jsonPayload: {
          ...entry.context,
        },
      },
      timestamp: entry.timestamp,
      error: entry.error,
    });
  }
}
